// removed by extract-text-webpack-plugin
module.exports = {"toolbar":"_2QU6wCavbr11Vc3OzqCgmo"};


//////////////////
// WEBPACK FOOTER
// ./src/views/BillingOrders/styles.css
// module id = 1083
// module chunks = 0